import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import Iconify from "minimals-template/components/Iconify"
import { Feature, isEnabled } from "lib/@components/feature"
import { registerTab } from "lib/@components/tabs"
import { authoringRoute } from "../authoring.runtime"
import { LegislationLibraryPage } from "./legislation-library-page"
import { LegislationDetailPage } from "./legislation-detail-page"
import { FEATURE_FLAG_LEGISLATION_LIBRARY } from "./feature-flag-legislation-library.js"
import { LEGISLATION_LIBRARY_ROOT } from "./legislation-library-navigation"
import { LegislationLibraryItemContextMenu } from "./components/legislation-library-context-menu"
import { LegislationLibraryEditMenuItem } from "./components/legislation-library-edit-menu-item"
import { LegislationLibraryDeleteMenuItem } from "./components/legislation-library-delete-menu-item"
import { LegislationSchedulesTab } from "./components/legislation-schedules-tab"
import { LEGISLATION_DETAIL_RIGHT_BAR_ID } from "./components/legislation-detail-sidebar"

authoringRoute.register(
    "legislation",
    <Feature feature={FEATURE_FLAG_LEGISLATION_LIBRARY}>
        <LegislationLibraryPage $lazy />
    </Feature>
)

authoringRoute.register(
    "legislation/:id",
    <Feature feature={FEATURE_FLAG_LEGISLATION_LIBRARY}>
        <LegislationDetailPage $lazy />
    </Feature>
)

LegislationLibraryItemContextMenu.plug(<LegislationLibraryEditMenuItem priority={10} />)
LegislationLibraryItemContextMenu.plug(<LegislationLibraryDeleteMenuItem priority={20} />)

registerTab({
    tab: LEGISLATION_DETAIL_RIGHT_BAR_ID,
    id: "Schedules",
    title: "Schedules",
    content: <LegislationSchedulesTab priority={10} />,
})

registerConditionalPageNavigation(
    () => isEnabled(FEATURE_FLAG_LEGISLATION_LIBRARY),
    LEGISLATION_LIBRARY_ROOT,
    "Legislation",
    <Iconify icon="mdi:scale-balance" />,
    {
        group: "Libraries",
        priority: 580,
        subPaths: true,
    }
)
